import {useStore} from 'vuex'
import {computed, watch, reactive, ref} from 'vue'
import TableComponentGeneric from '../TableComponentGeneric/TableComponentGeneric.vue'
import debounce from "../../foundation/js/deBounce";

export default {
    name: "SelectedBulkOverview",
    components:{
        TableComponentGeneric
    },
    setup(){
        const store = useStore()

        const bulkOrder = computed(() => store.getters['bulkOrder/getProducts'])
        const spinnerVisible = ref(false)
        const noSelectedProducts = computed(()=> bulkOrder.value.length === 0)
        const userIsLoggedIn = computed(() => store.state.main.user_logged_in_status)

        const productTableData = reactive({
            entries: bulkOrder.value,
            columns: [
                {
                    "id": "quantity",
                    "order": 0,
                },
                {
                    "id": "status",
                    "order" : 1
                },
                {
                    "id": "itemName",
                    "order" : 2
                },
                {
                    "id": "itemNo",
                    "order" : 3
                },
                {
                    "id": "price",
                    "order" : 4
                },
                {
                    "id": "colli",
                    "order" : 5
                }
            ]
        })

        const addToCart = debounce(function () {
            spinnerVisible.value = true
            store
              .dispatch("bulkOrder/add_to_cart")
              .then(() => {
                spinnerVisible.value = false
                store.commit('productSearch/set_products',[])
                store.commit('productSearch/set_displayed_count', { displayedCount: 0 })
                store.commit('bulkOrder/clear_products')
              })
              .catch((err) => {
                console.error(err)
              })
          }, 400);
      
        const getLabel = (labelRequested) => {
            return store.getters['labels/getLabel'](labelRequested)
        }

        watch(productTableData, (newValue) => {
            store.dispatch('bulkOrder/update_products', newValue)
        }, { deep: true })
        watch(bulkOrder, () => {
            productTableData.entries = bulkOrder
        }, { deep: true})

        return {
            userIsLoggedIn,
            noSelectedProducts,
            spinnerVisible,
            getLabel,
            addToCart,
            productTableData
        }
    }
}